import React from 'react';
import { AUDIENCES } from '../data/content';
export function MadeFor() {
  return <section aria-labelledby="madefor-title" className="w-full bg-soft px-3 py-6 sm:px-5" data-id="element-161" data-mp="uv4cbvfl6jb5">
      <div className="mx-auto max-w-5xl" data-id="element-162" data-mp="pw01l0d0kdip">
        <h2 id="madefor-title" className="text-center font-head text-2xl uppercase leading-[0.98] text-navy sm:text-4xl" data-id="element-163" data-mp="px2pr0iyc1ux">
          Made for anyone helping a child learn
        </h2>

        <div className="mt-3 grid gap-2 sm:grid-cols-2 lg:grid-cols-4" data-id="element-164" data-mp="1ikykw0svhlpl">
          {AUDIENCES.map(item => {
          const Icon = item.icon;
          return <div key={item.title} className="flex flex-col rounded-xl border border-line bg-white p-3 text-center" data-id="element-165" data-mp="1dnozcw8ltu71">
                <Icon className={`mx-auto h-6 w-6 ${item.accent}`} aria-hidden="true" data-id="element-166" data-mp="13vso0jhic7kv" />
                <h3 className="mt-1 font-head text-base uppercase leading-none text-navy sm:text-lg" data-id="element-167" data-mp="13tydlz3v3xv1">
                  {item.title}
                </h3>
                <p className="mt-1 text-[12px] leading-snug text-muted" data-id="element-168" data-mp="1wjf1cjgjeqkx">{item.body}</p>
              </div>;
        })}
        </div>

        <p className="mt-3 text-center font-head text-base uppercase leading-tight text-green sm:text-xl" data-id="element-169" data-mp="2rtem02rsy6by">
          One goal: make learning easier to understand.
        </p>
      </div>
    </section>;
}